import React from 'react'
import { CheckLg, ExclamationTriangle, Trash } from 'react-bootstrap-icons'
import AppModal from './AppModal'
import ModalActions from './ModalActions'

const TONE_ICONS = {
  danger: <Trash />,
  warning: <ExclamationTriangle />,
  primary: <CheckLg />,
  success: <CheckLg />,
  info: <ExclamationTriangle />,
}

/**
 * One question, two answers.
 *
 * Two rules this component exists to enforce: the confirm button says the verb
 * ("Delete banner"), never "Yes" or "OK"; and the body names the specific
 * record and states the consequence, so the prompt is readable on its own.
 */
const ConfirmModal = ({
  show,
  onHide,
  onConfirm,
  title,
  body,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'primary',
  icon,
  loading = false,
  error,
  size = 'sm',
}) => (
  <AppModal
    show={show}
    onHide={onHide}
    size={size}
    className='app-modal--confirm'
    title={title}
    icon={icon || TONE_ICONS[tone] || TONE_ICONS.primary}
    tone={tone}
    footer={
      <ModalActions
        onCancel={onHide}
        cancelLabel={cancelLabel}
        submitLabel={confirmLabel}
        onSubmit={onConfirm}
        tone={tone}
        loading={loading}
        error={error}
      />
    }
  >
    {typeof body === 'string' ? <p>{body}</p> : body}
  </AppModal>
)

export default ConfirmModal
